import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    position: number;
    userIds: string;
};

export const schemaLoanRequestResolver_GetCountByUserIds = z.record(
    z.string(),
    z.object({
        day: z.number(),
        month: z.number(),
    }),
);

export type SchemaLoanRequestResolver_GetCountByUserIds = z.infer<typeof schemaLoanRequestResolver_GetCountByUserIds>;

export type LoanRequestResolver_GetCountByUserIds = Resolver<Arguments, SchemaLoanRequestResolver_GetCountByUserIds>;
